module.exports = __webpack_public_path__ + "img/6-sdg-full@2x.14a184ca.png";